module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_vital_stats-14e28614abf427bf6c43b537e6036620.png";